import { render, staticRenderFns } from "./BaseAdminForm.vue?vue&type=template&id=184263e6&scoped=true&"
import script from "./BaseAdminForm.vue?vue&type=script&lang=js&"
export * from "./BaseAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdminForm.vue?vue&type=style&index=0&id=184263e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184263e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VContainer,VForm,VRow})
